import React from "react";
import { STEPS } from "@/data/content";
import { Reveal } from "@/components/site/reveal";

export default function HowItWorks() {
  return (
    <section id="process" className="bg-bone py-24 md:py-32" data-testid="process-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="max-w-2xl">
          <Reveal><p className="text-[11px] uppercase tracking-[0.3em] text-gold font-semibold">How It Works</p></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 font-serif text-4xl leading-tight text-navy sm:text-5xl md:text-6xl">
              Four steps to<br />hands-off.
            </h2>
          </Reveal>
        </div>

        <div className="mt-16 grid gap-px border border-navy/10 bg-navy/10 sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.08}>
              <div className="group relative flex h-full flex-col bg-bone p-8 transition-colors duration-500 hover:bg-navy lg:p-10" data-testid={`step-${s.n}`}>
                <span className="font-serif text-5xl text-gold">{s.n}</span>
                <h3 className="mt-6 font-serif text-2xl text-navy transition-colors duration-500 group-hover:text-white">{s.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-navy/55 transition-colors duration-500 group-hover:text-white/60">{s.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
